var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('user-info',{attrs:{"userInfo":_vm.userData}}),_c('div',{attrs:{"id":"list_datatable w-full"}},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full"},[_c('fund-history-table',{attrs:{"headers_prop":_vm.headers,"loading":_vm.loading,"list_url_prop":`/utilities/get-funds/${_vm.user_id}`}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }